import { Classes } from "@blueprintjs/core";
import React from "react";
import styled from "styled-components";

import { ShowOnHover, ShowOnHoverContainer } from "../../common/ShowOnHover.js";

export const HOME_SIDEBAR_WIDTH = 264;
export const MINIMIZED_HOME_SIDEBAR_WIDTH = 48;

export interface MenuItemTextWithShowOnHoverProps {
  hoverContent: React.ReactNode;
  text: string | React.ReactNode;
  id: string;
  className?: string;
}

export const MenuItemTextWithShowOnHover =
  React.memo<MenuItemTextWithShowOnHoverProps>(
    function MenuItemTextWithShowOnHover({
      className,
      hoverContent,
      id,
      text,
    }) {
      return (
        <StickyShowOnHoverContainer id={id}>
          <div className={`${className} ${Classes.TEXT_OVERFLOW_ELLIPSIS}`}>
            {text}
          </div>
          <StickyShowOnHover data-controller={id}>
            {hoverContent}
          </StickyShowOnHover>
        </StickyShowOnHoverContainer>
      );
    },
  );

const StickyShowOnHover = styled(ShowOnHover)<{
  "data-controller": string;
}>`
  display: flex;
  position: absolute;
  right: 0;
  align-items: center;
`;

const StickyShowOnHoverContainer = styled(ShowOnHoverContainer)<{
  id: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${StickyShowOnHover} {
    @media only screen and (hover: none) {
      position: static;
    }
  }

  &:hover ${StickyShowOnHover} {
    &[data-controller="${({ id }) => id}"] {
      position: static;
    }
  }
`;
